import { useState } from 'react';
import { useContent } from '@/hooks/useContent';

const getFaqs = (t: (key: string) => string) => [
  { q: t('faq_q1'), a: t('faq_a1') },
  { q: t('faq_q2'), a: t('faq_a2') },
  { q: t('faq_q3'), a: t('faq_a3') },
  { q: t('faq_q4'), a: t('faq_a4') },
  { q: t('faq_q5'), a: t('faq_a5') },
  { q: t('faq_q6'), a: t('faq_a6') },
];

export default function FAQSection() {
  const { t } = useContent('about');
  const [openIndex, setOpenIndex] = useState<number>(0);
  const faqs = getFaqs(t);
  const { t: imgT } = useContent('images');

  return (
    <section className="py-20 bg-background-50 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-start gap-14 lg:gap-16">
          <div className="w-full lg:w-[55%]">
            <span className="text-primary-500 text-xs font-semibold uppercase tracking-widest">{t('faq_badge')}</span>
            <h2 className="text-3xl md:text-4xl font-extrabold text-foreground-50 mt-3 leading-tight">
              {t('faq_title')}
            </h2>
            <p className="text-foreground-400 mt-4 text-base leading-relaxed">
              {t('faq_desc')}
            </p>
            <div className="mt-8 space-y-3">
              {faqs.map((faq, idx) => (
                <div key={idx} className="bg-background-100 border border-white/5 rounded-xl overflow-hidden">
                  <button
                    className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
                    onClick={() => setOpenIndex(openIndex === idx ? -1 : idx)}
                  >
                    <span className="text-primary-500 text-sm font-semibold pr-4">{faq.q}</span>
                    <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-full shrink-0">
                      <i className={`${openIndex === idx ? 'ri-subtract-line' : 'ri-add-line'} text-white text-sm w-4 h-4 flex items-center justify-center`}></i>
                    </div>
                  </button>
                  {openIndex === idx && (
                    <div className="px-5 pb-4">
                      <p className="text-foreground-400 text-sm leading-relaxed">{faq.a}</p>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>

          <div className="w-full lg:w-[45%] flex justify-center lg:sticky lg:top-24">
            <div className="relative w-full max-w-[480px]">
              <img
                alt="Completed insulation project by FMO LLC"
                className="w-full h-auto rounded-2xl"
                src={imgT('about_faq')}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}